(function ($) {

    'use strict';

    /* CLASS DEFINITION
     * ========================= */

    let RoozTheme = function (settings) {
        this.settings = $.extend({}, settings);
    };

    RoozTheme.prototype = {

        initGoToTop: function () {
            let b = 300,
                c = 700,
                d = $('#back-to-top');

            $(window).scroll(function () {
                if ($(this).scrollTop() > b) {
                    d.addClass('back-to-top-is-visible');
                } else {
                    d.removeClass('back-to-top-is-visible');
                }
            });

            d.on('click', function (a) {
                a.preventDefault();
                $('body,html').animate({
                    scrollTop: 0
                }, c);
            });
        },

        initSearchForm: function () {
            let b = $(".header-search-form"),
                c = $("#search-field-top-bar"),
                d = $("#search-top-bar-submit"),
                e = $(".search-form-opener");

            e.on("click", function (a) {
                a.preventDefault(), e.toggleClass("hide"), b.toggleClass("opened"), setTimeout(function () {
                    c.focus()
                }, 300), "" !== c.val() && (d.addClass("submit-button").removeClass("close-button"), d.html('<span class="rz-search"></span>'))
            }), c.on("keyup", function () {
                "" !== $(this).val() ? (d.addClass("submit-button").removeClass("close-button"), d.html('<span class="rz-search"></span>')) : (d.addClass("close-button").removeClass("submit-button"), d.html('<span class="first-bar"></span><span class="second-bar"></span>'))
            }), d.on("click", function () {
                $(this).hasClass("submit-button") ? $(this).parent().submit() : (e.toggleClass("hide"), b.toggleClass("opened"))
            })
        },

        /**
         * modify anything caused by plugins
         */
        initPluginPatches: function () {
            /*
             * advanced-gutenberg
             */
            // collapsible advgb-toc block should be visible on load
            $('.advgb-toc-header.collapsed').siblings('.advgb-toc:first').css('display','inherit');
        },

        init: function () {
            let that = this;
            let methods = Object.getOwnPropertyNames(Object.getPrototypeOf(that)).sort().filter(m => typeof that[m] == 'function' && m !== 'init');
            for (const method of methods) {
                that[method]();
            }
        }
    };

    /* PLUGIN DEFINITION
	 * ======================== */

    $.fn.rooz = function (option, settings) {

        if (typeof option === 'object') {
            settings = option;
        }

        let $this = $(document.body),
            data = $this.data('rooz');

        if (!data) {
            $this.data('rooz', (data = new RoozTheme(settings || {})));
        }

        if (typeof option == 'string') {
            return data[option](settings);
        } else if (typeof option === 'object' || !option) {
            return data.init();
        } else {
            $.error('Method ' + option + ' does not exist on $.rooz');
        }
    };

})(jQuery);